// src/mocks/handlers/signage.handlers.js
import * as data from '../data/signage.demo';

export const campaigns = async (config) => {
    if (config.method === 'post') return { success: true, data: {} };
    if (config.method === 'put') return { success: true };
    if (config.method === 'delete') return { success: true };
    if (/\/campaigns\/\d+$/.test(config.url)) return data.campaigns[0];
    return data.campaigns;
};

export const activateCampaign = async () => ({ success: true });
export const deactivateCampaigns = async () => ({ success: true });
export const slides = async (config) => {
    if (config.method === 'put') return { success: true };
    if (config.method === 'delete') return { success: true };
    return data.slides;
};
export const getActive = async () => ({ campaign: data.activeCampaign });
